<div class="add-projects-modal">
  <div class="modal-header">
    <h2 class="modal-title">{{ title }}</h2>
    <button
      type="button"
      mat-icon-button
      class="close-btn"
      aria-label="Close"
      (click)="cancel()"
      [disabled]="saving"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="modal-body" novalidate>
    <!-- Row 1: Business Segment | Supporting LOB (autocomplete) -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Business Segment</mat-label>
      <input
        matInput
        formControlName="businessSegment"
        [matAutocomplete]="businessSegmentAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #businessSegmentAuto="matAutocomplete">
        <ng-container *ngIf="(filteredBusinessSegments$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt.code">
            {{ opt.label }}
          </mat-option>
          <mat-option
            *ngIf="isNewRefValue('businessSegment', opts)"
            class="add-new-option"
            [value]="typedValue('businessSegment')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('businessSegment') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Supporting LOB</mat-label>
      <input
        matInput
        formControlName="supportingLob"
        [matAutocomplete]="supportingLobAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #supportingLobAuto="matAutocomplete">
        <ng-container *ngIf="(filteredSupportingLobs$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt.code">
            {{ opt.label }}
          </mat-option>
          <mat-option
            *ngIf="isNewRefValue('supportingLob', opts)"
            class="add-new-option"
            [value]="typedValue('supportingLob')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('supportingLob') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Row 2: Product Suite | Agile Team (autocomplete) -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Product Suite</mat-label>
      <input
        matInput
        formControlName="productSuite"
        [matAutocomplete]="productSuiteAuto"
        maxlength="128"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #productSuiteAuto="matAutocomplete">
        <ng-container *ngIf="(filteredProductSuites$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt">{{ opt }}</mat-option>
          <mat-option
            *ngIf="isNewStringValue('productSuite', opts)"
            class="add-new-option"
            [value]="typedValue('productSuite')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('productSuite') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Agile Team</mat-label>
      <input
        matInput
        formControlName="agileTeam"
        [matAutocomplete]="agileTeamAuto"
        maxlength="128"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #agileTeamAuto="matAutocomplete">
        <ng-container *ngIf="(filteredAgileTeams$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt">{{ opt }}</mat-option>
          <mat-option
            *ngIf="isNewStringValue('agileTeam', opts)"
            class="add-new-option"
            [value]="typedValue('agileTeam')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('agileTeam') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Row 3: Project Name | Project ID -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Project Name</mat-label>
      <input matInput formControlName="projectName" maxlength="255" required />
      <mat-error *ngIf="form.get('projectName')?.hasError('required')">
        Project name is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Project ID</mat-label>
      <input matInput formControlName="projectIdCode" maxlength="64" required />
      <mat-error *ngIf="form.get('projectIdCode')?.hasError('required')">
        Project ID is required.
      </mat-error>
    </mat-form-field>

    <!-- Row 4: SVP | VP (autocomplete) -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>SVP</mat-label>
      <input
        matInput
        formControlName="svp"
        [matAutocomplete]="svpAuto"
        maxlength="255"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #svpAuto="matAutocomplete">
        <ng-container *ngIf="(filteredSvps$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt">{{ opt }}</mat-option>
          <mat-option
            *ngIf="isNewStringValue('svp', opts)"
            class="add-new-option"
            [value]="typedValue('svp')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('svp') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>VP</mat-label>
      <input
        matInput
        formControlName="vp"
        [matAutocomplete]="vpAuto"
        maxlength="255"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #vpAuto="matAutocomplete">
        <ng-container *ngIf="(filteredVps$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt">{{ opt }}</mat-option>
          <mat-option
            *ngIf="isNewStringValue('vp', opts)"
            class="add-new-option"
            [value]="typedValue('vp')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('vp') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Row 5: Functional Manager | Invoice Approver (autocomplete) -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Functional Manager</mat-label>
      <input
        matInput
        formControlName="functionalManager"
        [matAutocomplete]="functionalManagerAuto"
        maxlength="255"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #functionalManagerAuto="matAutocomplete">
        <ng-container *ngIf="(filteredFunctionalManagers$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt">{{ opt }}</mat-option>
          <mat-option
            *ngIf="isNewStringValue('functionalManager', opts)"
            class="add-new-option"
            [value]="typedValue('functionalManager')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('functionalManager') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Invoice Approver</mat-label>
      <input
        matInput
        formControlName="invoiceApprover"
        [matAutocomplete]="invoiceApproverAuto"
        maxlength="255"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #invoiceApproverAuto="matAutocomplete">
        <ng-container *ngIf="(filteredInvoiceApprovers$ | async) as opts">
          <mat-option *ngFor="let opt of opts" [value]="opt">{{ opt }}</mat-option>
          <mat-option
            *ngIf="isNewStringValue('invoiceApprover', opts)"
            class="add-new-option"
            [value]="typedValue('invoiceApprover')"
          >
            <mat-icon class="add-new-icon">add</mat-icon>
            Add "<strong>{{ typedValue('invoiceApprover') }}</strong>" as new
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Row 6: GL Business Unit | Bill to FU -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>GL Business Unit</mat-label>
      <input matInput formControlName="glBusinessUnit" maxlength="64" />
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Bill to FU</mat-label>
      <input matInput formControlName="billToFu" maxlength="64" />
    </mat-form-field>

    <!-- Row 7: Bill to MO | Status (edit-only) -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Bill to MO</mat-label>
      <input matInput formControlName="billToMo" maxlength="64" />
    </mat-form-field>

    <mat-form-field
      *ngIf="isEdit"
      appearance="outline"
      floatLabel="always"
      class="form-field"
    >
      <mat-label>Status</mat-label>
      <mat-select formControlName="status" required>
        <mat-option value="Active">Active</mat-option>
        <mat-option value="Inactive">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="!isEdit" class="form-field-spacer"></div>
  </form>

  <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>

  <div class="modal-footer">
    <button
      type="button"
      mat-stroked-button
      class="cancel-btn"
      (click)="cancel()"
      [disabled]="saving"
    >
      Cancel
    </button>
    <button
      type="button"
      mat-flat-button
      class="primary-btn"
      (click)="save()"
      [disabled]="saving || form.invalid"
    >
      <mat-progress-spinner
        *ngIf="saving"
        diameter="16"
        mode="indeterminate"
        class="save-spinner"
      ></mat-progress-spinner>
      <span>{{ saveLabel }}</span>
    </button>
  </div>
</div>
